import React, { VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const Text = styled.p`
  margin: 0;
`;
const Text2 = styled.p<{ theme: Theme }>`
  margin: ${({ theme }) => theme.spacing(0, 0, 1.5)};
`;
const Ul = styled.ul<{ hasComment: boolean; theme: Theme }>`
  margin: ${({ hasComment, theme }) =>
    hasComment ? theme.spacing(0, 0, 2.5) : theme.spacing(0)};
`;
const CommentFromSecretariat = styled.p<{ theme: Theme }>`
  margin: ${({ theme }) => theme.spacing(0, 0, 0.5)};
`;
const Comment = styled.p`
  margin: 0;
  white-space: pre;
`;
const Link = styled.a`
  font-weight: bold;
  text-decoration: underline;
`;

const useStyles = makeStyles({
  alertRoot: {
    width: '100%',
  },
});

interface Props {
  profileChangeRequest: {
    comment: string;
    changeRequestProfileItems: Array<{
      id: number;
      name: string;
      kind: string;
      profilePath: string;
    }>;
  };
}

const ProfileChangeRequest: VFC<Props> = ({ profileChangeRequest }: Props) => {
  const theme = useTheme();
  const { alertRoot } = useStyles();

  return (
    <Alert severity="error" classes={{ root: alertRoot }}>
      <Text>{T.translate('profileChangeRequest.text1')}</Text>
      <Text2 theme={theme}>{T.translate('profileChangeRequest.text2')}</Text2>
      <Ul hasComment={!!profileChangeRequest.comment} theme={theme}>
        {profileChangeRequest.changeRequestProfileItems.map(
          ({ id, name, profilePath }) => (
            <li key={id}>
              <Link href={profilePath}>{name}</Link>
            </li>
          ),
        )}
      </Ul>
      {profileChangeRequest.comment && (
        <>
          <CommentFromSecretariat theme={theme}>
            {T.translate('profileChangeRequest.commentFromSecretariat')}
          </CommentFromSecretariat>
          <Comment>{profileChangeRequest.comment}</Comment>
        </>
      )}
    </Alert>
  );
};

export default ProfileChangeRequest;
